// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10cJD","option":"styles_option__3kAST","active":"styles_active__vlucZ"};